var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResizeReduce = function SvgResizeReduce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.025A1 1 0 0 0 7 8.5a1 1 0 0 0-.375-.075H2.14a1 1 0 1 0 0 2h2.065L.29 14.31a1 1 0 1 0 1.4 1.4l3.915-3.915v2.065a1 1 0 1 0 2 0V9.4a1 1 0 0 0-.105-.375ZM16 1a1 1 0 0 0-1.69-.71l-3.915 3.915V2.14a1 1 0 0 0-2 0V6.6A1 1 0 0 0 8.5 7c.052.117.125.224.215.315h.025c.077.074.165.137.26.185.122.05.253.075.385.075h4.46a1 1 0 1 0 0-2h-2.05L15.71 1.66A.97.97 0 0 0 16 1Z"
  })));
};
export default SvgResizeReduce;